import * as ActionTypes from '../ActionTypes';

export const GetMyAttendancePermissionAction = (params, callback) => {
    return {
        type: ActionTypes.GET_MY_ATTENDANCE_PERMISSION_REQUEST,
        params,
        callback
    }
}

export const UpsertMyAttendancePermissionAction = (params, callback) => {
    return {
        type: ActionTypes.UPSERT_MY_ATTENDANCE_PERMISSION_REQUEST,
        params,
        callback
    }
}

export const DeleteMyAttendancePermissionAction = (params, callback) => {
    return {
        type: ActionTypes.DELETE_MY_ATTENDANCE_PERMISSION_REQUEST,
        params,
        callback
    }
}

export const GetApproverEmpPermissionMappingAction = (params, callback) => {
    return {
        type: ActionTypes.GET_APPROVER_EMP_PERMISSION_MAPPING_REQUEST,
        params,
        callback
    }
}

export const UpdateApproverEmpPermissionMappingAction = (params, callback) => {
    return {
        type: ActionTypes.UPDATE_APPROVER_EMP_PERMISSION_MAPPING_REQUEST,
        params,
        callback
    }
}
